<template>
    <router-link :to="`/events/${item.slug}`" class="h-full w-full flex flex-col bg-white shadow-lg relative">
        <div class="absolute -top-4 w-full flex justify-center">
            <div class="bg-primary text-white px-4 h-8 flex items-center justify-center uppercase text-sm">{{ eventDate }}</div>
        </div>
        <div class="h-full w-full flex flex-col px-8 pt-8 pb-8">
            <h1 class="text-center text-xl mb-8">{{ item.title }}</h1>
            <div v-if="item.display_time" class="flex-auto flex flex-col justify-end">
                <p class="text-center text-sm font-light">{{ startTime }} - {{ endTime }}</p>
            </div>
        </div>
        <div v-if="item.entity" class="absolute bottom-0 left-0">
            <div class="pl-4 pb-4">
                <img class="h-8" :src="getEntityImage" :alt="item.title">
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: "events-card",
    props: ["item"],
    computed: {
        // getImage() {
        //     return process.env.VUE_APP_PUBLIC_URL + this.item.thumbnail;
        // },
        getEntityImage() {
            return process.env.VUE_APP_PUBLIC_URL + this.item.entity.logo;
        },
        eventDate() {
            const start_date = new Date(this.item.start_date);
            const end_date = new Date(this.item.end_date);

            const startMonth = start_date.toLocaleString('default', { month: 'short' });
            const startDate = start_date.getDate();
            const endDay = end_date.getDate();
            const year = start_date.getFullYear();

            let formattedDate = startMonth;

            if (this.item.display_day) {
                if (startDate !== endDay) {
                    formattedDate += ` ${startDate}-${endDay}, ${year}`;
                } else {
                    formattedDate += ` ${startDate}, ${year}`;
                }
            } else {
                formattedDate += ` - ${year}`;
            }

            return formattedDate;
        },
        startTime() {
            return this.formatTime(this.item.start_date);
        },
        endTime() {
            return this.formatTime(this.item.end_date);
        }
    },
    methods: {
        formatTime(datetime) {
            const date = new Date(datetime);
            const options = { hour: 'numeric', minute: 'numeric', hour12: true };
            return date.toLocaleTimeString([], options);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>